var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 45.7 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 52.9H11.2c-2.2 0-4-1.9-4-4.3V4.3C7.2 2 9 0 11.2 0h24.4c1.1 0 2.1.5 2.9 1.3L44.6 8c.7.8 1.1 1.9 1.1 3v37.7c0 2.3-1.8 4.2-4 4.2zM11.2 3c-.6 0-1.1.6-1.1 1.3v44.4c0 .7.5 1.3 1.1 1.3h30.6c.6 0 1.1-.6 1.1-1.3V10.9c0-.4-.1-.7-.4-1l-6.1-6.7c-.3-.1-.6-.2-.8-.2H11.2zm25.9 57H4.2C1.9 60 0 58 0 55.6v-47a1.54 1.54 0 0 1 1.5-1.5A1.54 1.54 0 0 1 3 8.6v47c0 .8.5 1.4 1.2 1.4h32.9a1.54 1.54 0 0 1 1.5 1.5 1.54 1.54 0 0 1-1.5 1.5z"
  })));
};
export default SvgCopy;